// (c) chaehongee. Confidential and proprietary.

import { useAuth } from './useAuth'
import { useAppSelector } from './hooks'
import { selectActiveSession } from '../selectors/sessionSelectors'

/**
 * Hook to determine if UI should be in read-only mode.
 * Used by Canvas, Thread, and other components to disable editing.
 * 
 * @returns true if the user is not authenticated OR if they don't have write access to the session.
 */
export function useReadOnlyMode(): boolean {
    const { user } = useAuth()
    const session = useAppSelector(selectActiveSession)

    // 1. Not authenticated -> Read-only
    if (!user) return true

    // 2. Authenticated but no session context (or loading)
    // If we are in a context where session matters (Canvas), we should default to read-only until we know.
    if (!session) return true

    // 3. Owner -> Write access
    if (session.user_id === user.id) return false

    // 4. Shared user -> Write access
    // shared_with is array of user IDs
    if (session.shared_with?.includes(user.id)) return false

    // 5. Public session, authenticated, but not owner/shared -> Read-only
    return true
}
